import { useState } from 'react';
import { Container } from './styled';
import {
    Avatar
} from '../../../../../components';
import { Charts, ChartFull } from '../../../../../components';
import { GiResize } from "react-icons/gi";

export function ChartUser({ user, objKey, className }) {

    const [openFullChart, setOpenFullChart] = useState(false);

    const generateChartData = (userData) => {

        const groupByKey = (key) => {
            return userData.reduce((accumulator, item) => {
                accumulator.push(item[key]);
                return accumulator;
            }, []);
        };
        const chartData = {
            labels: groupByKey(objKey),
            datasets: [
                {
                    label: 'Atendimentos',
                    data: groupByKey('total'),
                    backgroundColor: 'rgba(75, 192, 192, 1)',
                    borderColor: 'rgba(75, 192, 192, 1)',
                    borderWidth: 2,
                    fill: false,
                },
                {
                    label: 'Clientes Atendidos',
                    data: groupByKey('total_clientes'),
                    backgroundColor: 'rgba(255, 99, 132, 1)',
                    borderColor: 'rgba(255, 99, 132, 1)',
                    borderWidth: 2,
                    fill: false,
                },
            ],
        };
        return chartData;
    };

    return (
        <>
            <Container className={className}>
                <div className='info--'>
                    <div className='logo--'>
                        <Avatar
                            name={user[0]?.usuario}
                            width={'100%'}
                            height={'100%'}
                            borderRadius={'4px'}
                        />
                    </div>
                    <div className='name--company'>
                        <span>
                            {` - ${user[0]?.usuario}`}
                        </span>
                    </div>
                </div>
                <div className='full--'>
                    <span onClick={() => setOpenFullChart(true)}>
                        <GiResize fontSize={'1.75rem'} />
                    </span>
                </div>
                <div className='--chart'>
                    <Charts
                        type='Line'
                        data={generateChartData(user)}
                    />
                </div>
            </Container >
            {(openFullChart) &&
                (<ChartFull
                    onClose={() => setOpenFullChart(false)}
                    title={`${user[0]?.usuario}`}
                    dataChart={
                        {
                            type: "Line",
                            data: generateChartData(user)
                        }
                    }
                />)
            }
        </>

    );
}
